import { render, staticRenderFns } from "./FormPerVoucher.vue?vue&type=template&id=52a0f6f2"
import script from "./FormPerVoucher.vue?vue&type=script&lang=js"
export * from "./FormPerVoucher.vue?vue&type=script&lang=js"
import style0 from "./FormPerVoucher.vue?vue&type=style&index=0&id=52a0f6f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports